import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Disiscrizione con un clic dal link in calce all'email.
export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    axios
      .post(`${API}/unsubscribe/${token}`)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md text-center">
        {state === "loading" && <p className="text-chalk">Elaborazione in corso...</p>}
        {state === "ok" && (
          <>
            <h1 className="mb-3 font-display text-2xl font-semibold text-chalk">Disiscrizione completata</h1>
            <p className="text-steel">Non riceverai piu' email di recupero carrello. Puoi continuare ad acquistare su rinovotech.it quando vuoi.</p>
          </>
        )}
        {state === "error" && (
          <p className="text-chalk">Link non valido. Se continui a ricevere email non desiderate, scrivici a info@rinovotech.it.</p>
        )}
      </div>
    </div>
  );
}
